(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name notificationsLog.controller:NotificationsLogCtrl
   *
   * @description
   *
   */
  angular
    .module('notificationsLog')
    .controller('NotificationsLogCtrl', NotificationsLogCtrl);

  function NotificationsLogCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'NotificationsLogCtrl';

    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        smsStatus : null,
        flightNumber : null,
        crewId : null
      },
      masterList : {
        smsStatusList : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchNotificationLog(params);
    };

    // when change field in search
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    // validate Date
    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
    }

    // check from date and to date
    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    }

    // search notification log
    function searchNotificationLog(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var url = CommonLogicService.getReportUrl(
          "flight_crew_notification_log_report.rptdesign",
          getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;

      if(param.smsStatus != null){
        searchParamMap["status"] = param.smsStatus.statusValue;
      }
      if(param.flightNumber != null){
        searchParamMap["flightNumber"] = param.flightNumber;
      }
      if(param.crewId != null){
        searchParamMap["crewId"] = param.crewId;
      }

      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      if (!!vm.model.searchCriteria.fromDate
        && !vm.model.masterList.fromDateFormatInvalid
        && !!vm.model.searchCriteria.toDate
        && !vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateAfterToDate) {
        return true;
      }
      return false;
    }

    (function() {
      vm.model.masterList.smsStatusList.push({statusValue: "CNF", status: "Confirmed"});
      vm.model.masterList.smsStatusList.push({statusValue: "DLV", status: "Delivered"});
      vm.model.masterList.smsStatusList.push({statusValue: "FLD", status: "Failed"});
      vm.model.masterList.smsStatusList.push({statusValue: "NTF", status: "Not Found"});
      vm.model.masterList.smsStatusList.push({statusValue: "PND", status: "Pending"});
      vm.model.masterList.smsStatusList.push({statusValue: "SNT", status: "Sent"});
    })();

  }
}());
